// 日本語テーブル（機械翻訳・未校正 — ruling G4）。
// The Japanese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
const S = {
  styleGroup: "コースタースタイル",
  styles: {
    two: "両面",
    logo: "名前 / ロゴ",
  },
  titles: {
    two: "両面コースター",
    logo: "ロゴ入りコースター",
  },
  textHint: (lines, chars) => `最大 ${lines} 行、各行 ${chars} 文字まで`,
  needFile: "ロゴのSVGファイルを選んでください — 端末内に留まり、どこにも送信されません",
  artKept: "ロゴはこのタブ内にだけ存在します — 再読み込み後はファイルを再選択してください",
  keptOld: "（引き続き前のロゴを使用）",
  thumb: "読み込んだロゴのプレビュー",
  finish: "ロゴスタイル",
  finishes: {
    flush: "フラッシュ",
    raised: "盛り上げ",
    engraved: "彫刻",
  },
  finishNote: {
    flush: "表面とフラットでロゴは2色目 — マルチカラープリンターと3MFファイルが必要です（STLにロゴはなく閉じています）",
    raised: (mm) => `盛り上げ ${mm} mm — 単ノズルプリンターでも1回の色替えで2色になります（「プリント」で「単ノズル」を選ぶ）。ロゴが狭いとコップが不安定になることがあります`,
    engraved: (mm) => `彫刻 ${mm} mm — 1色で色替え不要`,
  },
  flushNeedsMulti: "フラッシュは単ノズルでプリントできません — マルチカラーを選んでください",
  scale: "ロゴサイズ",
  logoColour: "ロゴの色",
  logoPartNames: {
    body: "コースター本体",
    message: "ロゴ",
  },
  logoZNames: {
    body: "本体の色",
    message: "ロゴの色",
  },
  logoEdgeNote: {
    lip: (mm) => `縁が ${mm} mm 高くなり飲み物を受け止めます`,
    flat: "縁なし — 同じ高さの面",
  },
  gShape: "形状とエッジ",
  gColour: "カラーとプリント",
  a: "A面の言葉",
  b: "B面の言葉",
  wordHint: "B面は向かい側の人向け — 短い言葉が読みやすいです（6文字以内）",
  rows: (n) => `${Math.floor(n)} 行`,
  shape: "形",
  shapes: {
    round: "丸",
    square: "四角",
  },
  views: {
    a: "A面",
    b: "B面",
    top: "上面から",
  },
  d: {
    round: "直径",
    square: "幅",
  },
  mm: (v) => `${v} mm`,
  edge: "エッジ",
  edges: {
    lip: "立ち上がり縁",
    flat: "フラットエッジ",
  },
  edgeNote: {
    lip: "縁は土台より1.2 mm高く、飲み物を受け止めます",
    flat: "縁は土台と同じ高さ — 飲み物は溝に収まります",
  },
  looks: "カラーテーマ",
  lookNames: {
    night: "ナイト",
    bee: "黒黄",
    wood: "ウッド",
  },
  colour: {
    body: "コースター本体の色",
    message: "文字の色",
  },
  mode: "プリント",
  modes: {
    multi: "マルチ（CFS/AMS）",
    swap: "単ノズル",
  },
  modeNote: {
    multi: "3MFは2パーツです — スライサーで各パーツの色を設定してください",
    swap: (z1, z2) => `レイヤー高さ0.2 mm でプリントし、下の図の通り色替えしてください（パーツの ${z1} と ${z2} mm）`,
    swapOne: (layer, z) => `レイヤー高さ ${layer} mm でプリントし、下の図の通り色替えしてください（パーツの ${z} mm）`,
    lipToo: "立ち上がり縁もロゴの色でプリントされます",
    oneColour: "1色 — 色替えの設定は不要です",
  },
  zLine: (layer, filament, name) => `レイヤー ${layer} の前に ${filament}（${name}）を装着`,
  partNames: {
    body: "コースター本体",
    message: "テキスト",
  },
  zNames: {
    body: "本体の色",
    message: "文字の色",
  },
  size: (shape, d, h) => (shape === 'round' ? `Ø ${d} × ${h} mm` : `${d} × ${d} × ${h} mm`),
  hold: (ml) => `約 ${Math.round(ml)} ml を受け止めます`,
  loadingFont: (family, got, total) => (total > 0 ? `${family} を読み込み中 ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `${family} を読み込み中 ${got.toFixed(1)} MB`),
  problem: {
    "few-rows-a": "A面の言葉が長すぎます — 文字の行数が減って読みにくいです — もっと短い言葉をお試しください",
    "few-rows-b": "B面の言葉が長すぎます — 文字の行数が減って読みにくいです — もっと短い言葉をお試しください",
    "light-body": "コースター本体は文字より暗くしてください — そうでないと文字が目立ちません",
    "thin-text": "文字がとても細い — プリントできない線があるかもしれません — より大きいロゴか少ない文字数でお試しください",
    "same-colour": "ロゴの色がコースター本体と同じです — ロゴが見えなくなります",
    "thin-parts": "ロゴの太い部分に細い線が付いています — スライサーで切り捨てられる可能性があります",
    dropped: (p) => `薄すぎてプリントできない部分 ${p.n} 個をロゴから落としました`,
    "all-thin": "ロゴがこのサイズに対して薄すぎます — ダウンロードできません",
    "art-too-complex": "ロゴが複雑すぎます — ダウンロードできません",
  },
  dlstl: "STL",
  copied: "コピーしました",
  fatal: "計算機を読み込めません — ページを再読み込みしてください",
  buildTimeout: "生成が10秒で終わらず再開しました — 文字を減らすか別のフォントをお試しください",
  beta: "ベータ版",
  aboutH2: "両面コースターの仕組み",
  aboutP1: "コースターの盛り上がった筋の下に色の層が隠れています。A側に座る人には一方の言葉が、向かい側の人にはもう一方が見えます。真上からは文字は見えません。シミュレーションでは約 40–100 cm 離すと最も読みやすいです。",
  aboutP2: "0.2 mm 積層でプリントしてください。本体は暗色、文字は明るい色に。筋の間の溝がコップの張り付きを防ぎ、水滴を受け止めます — 使用後は水を拭いてください。",
  aboutPrintNote: "このデザインは光シミュレーションとスライスを通過済みです。実プリントの検証結果はまだありません。",
  aboutLogoP: "「名前 / ロゴ」タイプは平らなコースターです。テキストやお店の SVG ロゴファイルを配置でき、フラッシュ・盛り上げ・彫刻から選べます。ロゴファイルは端末から出ず、どこにも送信されません。注意: ノズル幅より細い線や文字の隙間は、スライサーに削られたりくっついてプリントされたりすることがあります — プリント前にスライサーで確認してください。このタイプは OrcaSlicer でスライス検証済みですが、実プリント検証はまだです。",
  // the words a page opened with no link starts on (R69): the English words — no bundled family has kana or Han
  start: {
    a: "Cheers",
    b: "LOVE",
  },
};
export default S;
